import type { DirectionCard } from "../domain.js";

const cssComment = (value: string): string => value.replace(/\*\//g, "* /").replace(/[\r\n\u2028\u2029]+/g, " ").trim();
const cssFontKey = (value: string): string => {
  if (!/^[a-z0-9_-]{1,120}$/i.test(value)) throw new Error(`Unsafe font manifest key in CSS export: ${value}`);
  return JSON.stringify(value);
};
const selectedType = (direction: DirectionCard) =>
  direction.type.recommendations.find((item) => item.systemId === direction.selected.typeSystemId) ?? direction.type.recommendations[0] ?? null;

export const exportCssCustomProperties = (direction: DirectionCard): string => {
  const type = selectedType(direction);
  const lines = [
    `/* Type Set — ${cssComment(direction.name)}`,
    `   Recommendation status: ${direction.truth.typeStatus}`,
    "   Values are font manifest keys. Resolve them through the attached official sources. */",
    ":root {",
  ];
  if (type) {
    lines.push(`  --type-set-font-display: ${cssFontKey(type.roles.display.fontId)};`);
    lines.push(`  --type-set-font-body: ${cssFontKey(type.roles.body.fontId)};`);
    lines.push(`  --type-set-font-utility: ${cssFontKey(type.roles.utility.fontId)};`);
  }
  lines.push("}", "");
  return lines.join("\n");
};

export const exportPlainTextStyleSheet = (direction: DirectionCard): string => {
  const type = selectedType(direction);
  const lines = [`TYPE SET — ${direction.name}`, ""];
  if (!type) {
    lines.push("No honest type recommendation survived.", ...direction.type.nextActions.map((line) => `- ${line}`));
  } else {
    lines.push(type.name, type.reason, "", `Headlines: ${type.roles.display.fontId}`, `Body copy: ${type.roles.body.fontId}`, `Labels and data: ${type.roles.utility.fontId}`, "", `Do not: ${type.oneThingNotToDo}`);
    if (type.caveats.length) lines.push("", "CAVEATS", ...type.caveats.map((line) => `- ${line}`));
  }
  lines.push("", "HONEST LIMIT", "This records a browser-proven direction. Test installation, editable handoff, and the final words in the application that will build the deck.", "");
  return lines.join("\n");
};

export const exportDesignTokens = (direction: DirectionCard): string => {
  const type = selectedType(direction);
  return `${JSON.stringify({
    schemaVersion: "1.0.0",
    product: "Type Set",
    projectId: direction.projectId,
    name: direction.name,
    recommendationStatus: direction.truth.typeStatus,
    typography: type ? {
      systemId: type.systemId,
      systemName: type.name,
      status: type.status,
      roles: type.roles,
      caveats: type.caveats,
      oneThingNotToDo: type.oneThingNotToDo,
    } : null,
  }, null, 2)}\n`;
};
